// The brand faces, self-hosted through Fontsource — the same faces the member app
// bundles, so the panel previews articles in the type they will actually render in.
import "@fontsource/syncopate/400.css";
import "@fontsource/syncopate/700.css";
import "@fontsource/gilda-display/400.css";
// The variable cut carries every weight the type scale uses in a single file.
import "@fontsource-variable/outfit";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "~/App";

const container = document.getElementById("root");
if (!container) throw new Error("Root container is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
